import * as React from 'react'

export const Rect = (props: { color: string; className?: string }) => (
  <svg width="6" height="6" viewBox="0 0 6 6" className={props.className}>
    <rect width="6" height="6" rx="1" ry="1" fill={props.color} />
  </svg>
)
